import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-6 sm:p-12 flex flex-col items-center justify-center gap-4 min-h-[300px]"
}
const _hoisted_2 = {
  key: 1,
  class: "p-6 sm:p-12 flex flex-col items-center justify-center gap-4 min-h-[300px]"
}
const _hoisted_3 = { class: "text-slate-600 text-xs sm:text-sm text-center max-w-md" }
const _hoisted_4 = {
  key: 2,
  class: "flex-1 overflow-y-auto p-6 space-y-6"
}
const _hoisted_5 = { class: "bg-gradient-to-r from-slate-50 to-blue-50 rounded-xl p-4 border border-slate-200" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" }
const _hoisted_7 = { class: "text-m font-bold text-slate-900" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-sm font-medium text-slate-700" }
const _hoisted_10 = { class: "bg-slate-50 rounded-xl p-4 border border-slate-200" }
const _hoisted_11 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_12 = { class: "text-sm font-medium text-slate-800" }
const _hoisted_13 = { class: "text-sm font-medium text-slate-800 truncate" }
const _hoisted_14 = { class: "text-sm font-medium text-slate-800" }
const _hoisted_15 = { class: "text-sm font-medium text-slate-800" }
const _hoisted_16 = { class: "border border-slate-200 rounded-xl overflow-hidden" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "divide-y divide-slate-200" }
const _hoisted_19 = { class: "px-4 py-3 text-sm text-slate-800" }
const _hoisted_20 = { class: "px-4 py-3 text-sm text-center text-slate-600" }
const _hoisted_21 = { class: "px-4 py-3 text-sm text-right text-slate-600" }
const _hoisted_22 = { class: "px-4 py-3 text-sm text-right font-medium text-slate-800" }
const _hoisted_23 = {
  key: 0,
  class: "bg-amber-50 rounded-xl p-4 border border-amber-200"
}
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-amber-900 mb-2"
}
const _hoisted_25 = { class: "font-mono ml-1 break-all" }
const _hoisted_26 = {
  key: 1,
  class: "text-sm text-amber-900 mb-2"
}
const _hoisted_27 = {
  key: 2,
  class: "text-left mt-3"
}
const _hoisted_28 = { class: "mt-2 text-xs bg-white p-3 rounded border border-amber-100 overflow-x-auto max-h-48 overflow-y-auto text-slate-700" }
const _hoisted_29 = {
  key: 1,
  class: "bg-slate-50 rounded-xl p-4 border border-slate-200"
}
const _hoisted_30 = {
  key: 0,
  class: "text-sm text-slate-700"
}
const _hoisted_31 = { class: "font-mono ml-1 break-all" }
const _hoisted_32 = {
  key: 1,
  class: "text-left mt-2"
}
const _hoisted_33 = { class: "mt-2 text-xs bg-white p-3 rounded border border-slate-200 overflow-x-auto max-h-40 overflow-y-auto text-slate-600" }
const _hoisted_34 = { class: "bg-blue-50 rounded-xl p-4 border-2 border-blue-200" }
const _hoisted_35 = { class: "flex justify-between items-center" }
const _hoisted_36 = { class: "text-2xl font-bold text-blue-600" }

import { usePedidosDetalles } from "@/modules/pedidos/composables";
import { computed } from "vue";

import type { Ref } from "vue";

interface Props {
  pedidoId: string;
  isOpen: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PedidoDetallesModal',
  props: {
    pedidoId: {},
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// Usar el composable para obtener los detalles
const {
  data: pedidoDetalles,
  isPending,
  isError,
  error,
} = usePedidosDetalles(computed(() => props.pedidoId) as Ref<string>);

// Función para formatear fecha (declarada antes de los computed que la usan)
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Computed para datos del pedido
const pedido = computed(() => pedidoDetalles.value?.data);
const cliente = computed(() => pedido.value?.data.cliente);
const productos = computed(() => pedido.value?.data.GpedPedidoProducto || []);
const estadoPedido = computed(() => pedido.value?.data.estadoPedido);

const commerceOrderCheckout = computed(
  () => pedido.value?.data.commerceOrderExterno ?? null
);

const fechaLimitePago = computed(() => {
  const snap = pedido.value?.data.pagoPendienteSnapshot;
  if (!snap || typeof snap !== "object") return null;
  const iso = (snap as Record<string, unknown>).fechaLimitePagoISO;
  if (typeof iso !== "string") return null;
  try {
    return formatDate(iso);
  } catch {
    return iso;
  }
});

const snapshotJson = computed(() => {
  const snap = pedido.value?.data.pagoPendienteSnapshot;
  if (!snap) return null;
  try {
    return JSON.stringify(snap, null, 2);
  } catch {
    return null;
  }
});

/** Nombre del estado (Pendiente, Pagado, etc.) — clave para no mostrar «pago pendiente» en pedidos ya cobrados. */
const nombreEstadoPedido = computed(() => (estadoPedido.value?.nombre ?? "").trim());

/** Solo en Pendiente: mostramos instrucciones al admin para acreditar manualmente. */
const esPendienteDeCobro = computed(() => nombreEstadoPedido.value === "Pendiente");

const mostrarBloquePagoPendienteAdmin = computed(
  () =>
    esPendienteDeCobro.value &&
    (!!commerceOrderCheckout.value || !!pedido.value?.data.pagoPendienteSnapshot),
);

/**
 * Si el pedido ya no está pendiente (Pagado, etc.) pero sigue con commerceOrder o
 * snapshot en BD, mostramos trazabilidad informativa — no la alerta de «ir a marcar como pagado».
 */
const mostrarTrazabilidadPasarela = computed(
  () =>
    !esPendienteDeCobro.value &&
    (!!commerceOrderCheckout.value || !!pedido.value?.data.pagoPendienteSnapshot),
);

// Función para formatear precio
const formatPrice = (price: string | number) => {
  return ` ${parseFloat(price.toString()).toFixed(2)}`;
};

// Cerrar modal
const handleClose = () => {
  emit("close");
};

// Cerrar al hacer clic fuera del modal
const handleBackdropClick = (e: MouseEvent) => {
  if (e.target === e.currentTarget) {
    handleClose();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm",
              onClick: handleBackdropClick
            }, [
              _createElementVNode("div", {
                class: "bg-white rounded-lg sm:rounded-xl shadow-2xl w-full max-w-4xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", { class: "bg-slate-900 border-b border-slate-700 px-4 sm:px-6 py-4 flex items-center justify-between" }, [
                  _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-lg sm:text-xl font-semibold text-white flex items-center gap-2" }, [
                    _createElementVNode("svg", {
                      class: "w-5 h-5 sm:w-6 sm:h-6 text-slate-300",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      })
                    ]),
                    _createElementVNode("span", { class: "hidden sm:inline" }, "Detalles del Pedido"),
                    _createElementVNode("span", { class: "sm:hidden" }, "Detalles")
                  ], -1)),
                  _createElementVNode("button", {
                    onClick: handleClose,
                    class: "text-slate-300 hover:text-white hover:bg-slate-800 rounded-lg p-1.5 sm:p-2 transition-colors",
                    "aria-label": "Cerrar modal"
                  }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("svg", {
                      class: "w-5 h-5 sm:w-6 sm:h-6",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))])
                ]),
                (_unref(isPending))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "relative" }, [
                        _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 sm:h-16 sm:w-16 border-4 border-slate-200" }),
                        _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 sm:h-16 sm:w-16 border-4 border-slate-900 border-t-transparent absolute top-0 left-0" })
                      ], -1),
                      _createElementVNode("p", { class: "text-slate-600 text-sm sm:text-base" }, " Cargando detalles del pedido... ", -1)
                    ]))]))
                  : (_unref(isError))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-red-100 rounded-full p-3 sm:p-4" }, [
                          _createElementVNode("svg", {
                            class: "w-10 h-10 sm:w-12 sm:h-12 text-red-600",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            })
                          ])
                        ], -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-red-600 font-semibold text-sm sm:text-base" }, " Error al cargar los detalles ", -1)),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(error)?.message), 1)
                      ]))
                    : (pedido.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", null, [
                                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs text-slate-500 mb-1" }, "Pedido", -1)),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(pedido.value.data.id), 1)
                              ]),
                              _createElementVNode("div", _hoisted_8, [
                                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-slate-500 mb-1" }, "Fecha de creación", -1)),
                                _createElementVNode("p", _hoisted_9, _toDisplayString(formatDate(pedido.value.data.createdAt)), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs text-slate-500 mb-1" }, "Estado", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass([
                      'inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold',
                      nombreEstadoPedido.value === 'Pendiente' &&
                        'bg-yellow-100 text-yellow-800 border-2 border-yellow-300',
                      nombreEstadoPedido.value === 'Completado' &&
                        'bg-green-100 text-green-800 border-2 border-green-300',
                      nombreEstadoPedido.value === 'Pagado' &&
                        'bg-blue-100 text-blue-800 border-2 border-blue-300',
                      nombreEstadoPedido.value === 'Cancelado' &&
                        'bg-red-100 text-red-800 border-2 border-red-300',
                    ])
                                }, _toDisplayString(nombreEstadoPedido.value || "—"), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-lg font-semibold text-slate-800 mb-3 flex items-center gap-2" }, [
                              _createElementVNode("svg", {
                                class: "w-5 h-5 text-blue-600",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                })
                              ]),
                              _createTextVNode(" Información del Cliente ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs text-slate-500 mb-1" }, "Cliente", -1)),
                                _createElementVNode("p", _hoisted_12, _toDisplayString(cliente.value?.nombreCliente) + " " + _toDisplayString(cliente.value?.apellidoCliente), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-slate-500 mb-1" }, "Correo", -1)),
                                _createElementVNode("p", _hoisted_13, _toDisplayString(cliente.value?.correoCliente), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs text-slate-500 mb-1" }, "Teléfono", -1)),
                                _createElementVNode("p", _hoisted_14, _toDisplayString(cliente.value?.telefono), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-slate-500 mb-1" }, "Dirección", -1)),
                                _createElementVNode("p", _hoisted_15, _toDisplayString(cliente.value?.direccionCliente), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-lg font-semibold text-slate-800 mb-3 flex items-center gap-2" }, [
                              _createElementVNode("svg", {
                                class: "w-5 h-5 text-blue-600",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                                })
                              ]),
                              _createTextVNode(" Productos ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("table", _hoisted_17, [
                                _cache[14] || (_cache[14] = _createElementVNode("thead", { class: "bg-slate-100" }, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-semibold text-slate-600" }, " Producto "),
                                    _createElementVNode("th", { class: "px-4 py-3 text-center text-xs font-semibold text-slate-600" }, " Cantidad "),
                                    _createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-semibold text-slate-600" }, " Precio Unit. "),
                                    _createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-semibold text-slate-600" }, " Total ")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productos.value, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: item.id,
                                      class: "hover:bg-slate-50"
                                    }, [
                                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.producto.nombreProducto), 1),
                                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.cantidad), 1),
                                      _createElementVNode("td", _hoisted_21, _toDisplayString(formatPrice(item.producto.precioProducto)), 1),
                                      _createElementVNode("td", _hoisted_22, _toDisplayString(formatPrice(item.total)), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          (mostrarBloquePagoPendienteAdmin.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-lg font-semibold text-amber-900 mb-2 flex items-center gap-2" }, [
                                  _createElementVNode("svg", {
                                    class: "w-5 h-5",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    })
                                  ]),
                                  _createTextVNode(" Pago pendiente (tienda / Izipay) ")
                                ], -1)),
                                (commerceOrderCheckout.value)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "font-medium" }, "Referencia pasarela (commerceOrder):", -1)),
                                      _createElementVNode("span", _hoisted_25, _toDisplayString(commerceOrderCheckout.value), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (fechaLimitePago.value)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "font-medium" }, "Plazo orientativo / vencimiento:", -1)),
                                      _createTextVNode(" " + _toDisplayString(fechaLimitePago.value), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-sm text-amber-800 leading-relaxed" }, [
                                  _createTextVNode(" Cuando hayas verificado el cobro (efectivo en agencia, depósito, etc.), ve a "),
                                  _createElementVNode("strong", null, "Pedidos pendientes"),
                                  _createTextVNode(" y usa el botón azul "),
                                  _createElementVNode("strong", null, "Marcar como pagado"),
                                  _createTextVNode(" para pasar el pedido a la lista de pagados. ")
                                ], -1)),
                                (snapshotJson.value)
                                  ? (_openBlock(), _createElementBlock("details", _hoisted_27, [
                                      _cache[18] || (_cache[18] = _createElementVNode("summary", { class: "text-sm font-medium text-amber-900 cursor-pointer select-none" }, " Datos guardados (snapshot) ", -1)),
                                      _createElementVNode("pre", _hoisted_28, _toDisplayString(snapshotJson.value), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (mostrarTrazabilidadPasarela.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "text-sm font-semibold text-slate-800 mb-2 flex items-center gap-2" }, [
                                    _createElementVNode("svg", {
                                      class: "w-4 h-4 text-slate-500 shrink-0",
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                                      })
                                    ]),
                                    _createTextVNode(" Referencia pasarela (trazabilidad) ")
                                  ], -1)),
                                  _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-sm text-slate-600 leading-relaxed mb-2" }, [
                                    _createTextVNode(" El pedido ya "),
                                    _createElementVNode("strong", null, "no"),
                                    _createTextVNode(" está en estado «Pendiente de cobro». El identificador de la pasarela se conserva solo para conciliación y auditoría. ")
                                  ], -1)),
                                  (commerceOrderCheckout.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "font-medium" }, "commerceOrder:", -1)),
                                        _createElementVNode("span", _hoisted_31, _toDisplayString(commerceOrderCheckout.value), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (snapshotJson.value)
                                    ? (_openBlock(), _createElementBlock("details", _hoisted_32, [
                                        _cache[22] || (_cache[22] = _createElementVNode("summary", { class: "text-sm font-medium text-slate-600 cursor-pointer select-none" }, " Ver snapshot histórico (opcional) ", -1)),
                                        _createElementVNode("pre", _hoisted_33, _toDisplayString(snapshotJson.value), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-lg font-semibold text-slate-700" }, "Total del Pedido:", -1)),
                              _createElementVNode("span", _hoisted_36, " S/ " + _toDisplayString(formatPrice(pedido.value.data.totalPedido)), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                _createElementVNode("div", { class: "border-t border-slate-200 px-4 sm:px-6 py-3 sm:py-4 bg-slate-50 flex justify-end gap-3" }, [
                  _createElementVNode("button", {
                    onClick: handleClose,
                    class: "w-full sm:w-auto px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white font-medium rounded-lg transition-all duration-200 shadow-sm hover:shadow-md flex items-center justify-center gap-2"
                  }, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1),
                    _createTextVNode(" Cerrar ", -1)
                  ]))])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})